export default __webpack_public_path__ + "static/media/automation_action.9521aac4.svg";